import {
  PostProductionGeneration,
  TargetResolution,
} from '@/types/postProductionGeneration';
import api from '../index';

export type StartResizeArgs = {
  campaignId: string;
  assetId: string;
  targetResolution: TargetResolution;
};

const postProductionGenerationUpdaters = {
  startResize: async ({
    campaignId,
    assetId,
    targetResolution,
  }: StartResizeArgs): Promise<PostProductionGeneration> => {
    const body = {target_resolution: targetResolution};
    const response = await api.post(
      `/campaigns/${campaignId}/assets/${assetId}/start_resize`,
      body,
      {customSerializer: () => body}
    );
    return (response as unknown as {data: PostProductionGeneration}).data;
  },
};

export default postProductionGenerationUpdaters;
